import React from "react";
import { BrowserRouter as Router, Routes, Route, Outlet, Navigate } from "react-router-dom";
import PrivacyPolicy from "./PrivacyPolicy";
import Terms from "./Terms";
import CookiePolicy from "./CookiePolicy"
import Download from "./Download";
import ContactUs from "./ContactUs";
import Career from "./Career";
import JobDetail from "./JobDetail";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import RevampHome from "./revamp/RevampHome";
import RevampHomeProfessionals from "./revamp/RevampHomeProfessionals";
import RevampNavbar from "./revamp/RevampNavbar";
import RevampCategoryMarquee from "./revamp/RevampCategoryMarquee";
import RevampFooter from "./revamp/RevampFooter";
import RevampRequirementsFlow from "./revamp/requirements/RevampRequirementsFlow";
import SucessScreen from "./Requirments/SucessScreen";
import CreateBusinessFlow from "./revamp/createBusiness/CreateBusinessFlow";
import CreateBusinessCategoryPage from "./revamp/createBusiness/CreateBusinessCategoryPage";
import CreateBusinessProfilePage from "./revamp/createBusiness/CreateBusinessProfilePage";
import CreateBusinessSuccessScreen from "./revamp/createBusiness/CreateBusinessSuccessScreen";
import ClaimAccountPage from "./revamp/claim/ClaimAccountPage";
import TakedownPolicy from "./TakedownPolicy";
import Form from "./Form/Form"
import { trackPageView, initSiteAnalytics } from "./utils/analytics";
import NotFoundPage from "./revamp/NotFoundPage";
import { ROUTE_ALIASES } from "./revamp/routeAliases";
import InstagramPage from "./utils/InstagramPage";
import { UtmProvider } from "./context/UtmContext";

const ROUTE_ALIAS_ENTRIES = Object.entries(ROUTE_ALIASES);

function App() {

  return (
    <Router>
      <UtmProvider>
        <Routes>
          {ROUTE_ALIAS_ENTRIES.map(([from, to]) => (
            <Route key={from} path={from} element={<Navigate to={to} replace />} />
          ))}
          <Route element={<RevampNavLayout />}>
            <Route path="/" element={<RevampHome />} />
            <Route path="/professionals" element={<RevampHomeProfessionals />} />
            <Route path="/contact" element={<ContactUs />} />
            <Route path="/requirement-success" element={<SucessScreen />} />
            <Route path="/enquiry" element={<RevampRequirementsFlow />} />
            <Route
              path="/enquiry/questions/:categoryParam"
              element={<RevampRequirementsFlow directCategoryRoute />}
            />
            <Route path="/create-business" element={<CreateBusinessFlow />} />
            <Route
              path="/create-business/category"
              element={<CreateBusinessCategoryPage />}
            />
            <Route
              path="/create-business/profile"
              element={<CreateBusinessProfilePage />}
            />
            <Route
              path="/create-business/success"
              element={<CreateBusinessSuccessScreen />}
            />
            <Route path="/careers" element={<Career />} />
            <Route path="/claim/:userId" element={<ClaimAccountPage />} />
            <Route path="/404" element={<NotFoundPage />} />
            <Route path="*" element={<Navigate to="/404" replace />} />
          </Route>
          <Route element={<PolicyLayout />}>
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/cookie-policy" element={<CookiePolicy />} />
            <Route path="/takedown-policy" element={<TakedownPolicy />} />
          </Route>
          <Route path="/downloads" element={<Download />} />
          <Route path="/careers/:jobId" element={<JobDetail />} />
          <Route path="/form" element={<Form />} />
          <Route path="/instagram" element={<InstagramPage />} />
        </Routes>
        <ScrollToTop />
        <RouteTracker />
      </UtmProvider>
    </Router>
  );
}

function RevampNavLayout() {
  return (
    <div className="revamp-layout-gradient">
      <div className="revamp-top-stack">
        <RevampNavbar />
        <RevampCategoryMarquee />
      </div>
      <Outlet />
      <RevampFooter />
    </div>
  );
}

function PolicyLayout() {
  return (
    <div className="revamp-layout-gradient">
      <div className="revamp-policy-header">
        <RevampNavbar />
      </div>
      <Outlet />
      <RevampFooter />
    </div>
  );
}

function RouteTracker() {
  const location = useLocation();

  useEffect(() => {
    const categoryParam = location.state?.categoryParam || "";
    trackPageView(location.pathname, location.search, { categoryParam });

    if (window.fbq) {
      window.fbq("track", "PageView");
    }
  }, [location]);

  useEffect(() => {
    return initSiteAnalytics();
  }, []);

  useEffect(() => {
    const handleBeforeInstallPrompt = (e) => {
      e.preventDefault();
      console.log("Install prompt prevented");
    };

    window.addEventListener("beforeinstallprompt", handleBeforeInstallPrompt);
    return () => {
      window.removeEventListener("beforeinstallprompt", handleBeforeInstallPrompt);
    };
  }, []);

  return null;
}

/**
 * Resets the scroll position to the top whenever the user navigates
 * to a new route via React Router. Without this, clicking a link in
 * the footer would land the user at whatever scroll position they
 * had on the previous page (or the bottom, if the link was in the
 * footer). Hash-only changes (in-page anchors) are intentionally not
 * triggered, because pathname is the only dependency.
 */
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    if (typeof window !== "undefined" && "scrollRestoration" in window.history) {
      // Disable the browser's automatic scroll restoration so it
      // doesn't fight our explicit scrollTo on every navigation.
      window.history.scrollRestoration = "manual";
    }
  }, []);

  useEffect(() => {
    if (typeof window === "undefined") return;
    window.scrollTo(0, 0);
    // Some pages may set scroll on the document element itself.
    if (document.documentElement) document.documentElement.scrollTop = 0;
    if (document.body) document.body.scrollTop = 0;
  }, [pathname]);

  return null;
}

export default App;
